import React from "react";
import { connect } from "react-redux";
import FiltroNetPay from "./list-transactions-stp/components/FiltroSTP";
import { listSTPAction } from "_models/redux/list-transfer-stp/action";
import { Grid, Typography } from "@mui/material";
import { PageSTPHook } from "./list-transactions-stp/hooks/PageSTPHook";
import CircularProgress from "@mui/material/CircularProgress";
import { CircularProgressStyle } from "./list-transactions-stp/style/style";
import DataTable from "widgets/datagrid/DataTable";
import CustomDialog from "widgets/component/CustomDialog";
import { detailSTPAction } from "_models/redux/detail-transactions-stp/action";
import { cleanTransferSTPClean } from "_models/redux/list-transfer-stp/clean-action";
import DataTableDetailOrder from "widgets/customDialogComponentDetails/componentDialog";
import { cleanDetailSTPAction } from "_models/redux/detail-transactions-stp/clean-action";

const PageSTP = ({
    listSTPAction,
    cleanTransferSTPClean,
    listTransactionsSTP,
    detailSTPAction,
    cleanDetailSTPAction,
    detailsTransactionsSTP,
}) => {
    const {
        register,
        handleSubmit,
        errors,
        onSubmit,
        handleCleanFilters,
        loading,
        page,
        size,
        pagination,
        mappedRows,
        handleRowClick,
        Columns,
        isDialogOpen,
        dialogMessage,
        handleClose,
        isDialogOpenDetails,
        errorMessage,
    } = PageSTPHook({
        listSTPAction,
        cleanTransferSTPClean,
        listTransactionsSTP,
        detailSTPAction,
        cleanDetailSTPAction,
        detailsTransactionsSTP,
    });

    return (
        <>
            <Grid>
                <h4> Transacciones de STP </h4>
            </Grid>
            <Grid marginBottom={4}>
                <FiltroNetPay
                    onSubmit={onSubmit}
                    handleSubmit={handleSubmit}
                    errors={errors}
                    register={register}
                    onCleanFilters={handleCleanFilters}
                />
                {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
            </Grid>
            <Grid>
                {loading ? (
                    <CircularProgress
                        style={CircularProgressStyle.CircularProgress}
                    />
                ) : (
                    <>
                        {mappedRows?.length > 0 ? (
                            <Grid paddingRight={5} paddingLeft={0}>
                                <DataTable
                                    rows={mappedRows}
                                    columns={Columns}
                                    onRowClick={handleRowClick}
                                    page={page}
                                    pageSize={size}
                                    rowCount={pagination?.total_rows ?? 0}
                                    onPageChange={pagination?.handleChangePage}
                                    handleChangePageSize={
                                        pagination?.handleChangePageSize
                                    }
                                />
                            </Grid>
                        ) : (
                            <Typography variant="h6">
                                No hay registros disponibles
                            </Typography>
                        )}
                    </>
                )}
            </Grid>

            <CustomDialog
                fullWidth
                title="Transacción STP"
                content={
                    <DataTableDetailOrder
                        response={detailsTransactionsSTP?.response}
                    />
                }
                open={isDialogOpenDetails}
                onClose={handleClose}
                maxWidth="md"
                extraButtons={[
                    {
                        label: "Aceptar",
                        variant: "contained",
                        onClick: handleClose,
                        buttonColor: "purple",
                        textColor: "white",
                    },
                ]}
            />

            <CustomDialog
                title="Mensaje"
                content={<p>{dialogMessage}</p>}
                open={isDialogOpen}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
                extraButtons={[
                    {
                        label: "Aceptar",
                        variant: "contained",
                        onClick: handleClose,
                        buttonColor: "purple",
                        textColor: "white",
                    },
                ]}
            />
        </>
    );
};

const mapStateToProps = (state) => ({
    listTransactionsSTP: state?.listTransactionsSTP,
    detailsTransactionsSTP: state?.detailsTransactionsSTP,
});

const mapDispatchToProps = {
    listSTPAction,
    cleanTransferSTPClean,
    listSTPAction,
    detailSTPAction,
    cleanDetailSTPAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageSTP);
